// App.js
import './App.scss';
import './components/studio/styles.scss';
import Nav from "./components/Nav";
import Banner from "./components/Banner";
import Footer from "./components/Footer";
import requests from "./config/Requests";
import Row from "./components/Row";
import Video from "./components/Video";
import Login from "./components/Login";  
import SignUp from "./components/SignUp";  
import UploadVideo from "./components/UploadVideo";  
import VideoList from "./components/VideoList";  
import VideoListPub from "./components/VideoListPub"; 
import VideoListStat from "./components/VideoListStat";  
import VideoDetailStat from "./components/VideoDetailStat";  
import VideoDetail from "./components/VideoDetail";    
import DashBoard from "./components/DashBoard";  
import VideoConfig from "./components/VideoConfig";
import UsersRegister from "./components/UsersRegister";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./context/ProtectedRoute";
import PublicRoute from "./context/PublicRoute";
import AdminLayout from "./context/AdminLayout";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>

          {/* ===== PUBLIC ===== */}
          <Route path="/" element={
            <>
              <Nav />
              <Banner />
              <Row title="Program d'aujourd'hui MyFlix" fetchUrl={requests.fetchTrending} isPoster />
              <Row title="Program populaire MyFlix" fetchUrl={requests.tvTrending} />
              <Row title="Program Actuel MyFlix" fetchUrl={requests.tvTrending} />
              <Footer />
            </>
          } />

          <Route path="/video/:id" element={
            <>
              <Nav />
              <Video />
              <Row title="Dans la même catégorie" fetchUrl={requests.fetchTrending} isPoster />
              <Footer />
            </>
          } />

          <Route path="/login" element={
              <Login />
          } />

          <Route path="/signup" element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          } />

          {/* ===== PROTECTED (admin layout) ===== */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<AdminLayout />}>

              {/* route par défaut / */}
              <Route index element={<DashBoard />} />

              {/* routes protégées */}
              <Route path="dashboard" element={<DashBoard />} />
              <Route path="upload" element={<UploadVideo />} />
              <Route path="video/config" element={<VideoConfig />} />
              <Route path="videolist" element={<VideoList />} />
              <Route path="videolist/pub" element={<VideoListPub />} />
              <Route path="videolist/statistique" element={<VideoListStat />} />
              <Route path="videoDetail/:id" element={<VideoDetail />} />
              <Route path="statistique/detail/:id" element={<VideoDetailStat />} />
              <Route path="users/register" element={<UsersRegister />} />

            </Route>
          </Route>

          {/* fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
